import { useState } from 'react';
import './SignupNewsletter.css';
import { useNavigate } from 'react-router-dom';

const SignupNewsletter = () => {
  const [isDisabled, setIsDisabled] = useState(false);
  const [email, setEmail] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const handleEmailChange = (e) => setEmail(e.target.value);
  const handleFirstNameChange = (e) => setFirstName(e.target.value);
  const handleLastNameChange = (e) => setLastName(e.target.value);

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsDisabled(true);
    setMessage('');

    // Save the timestamp to local storage
    const timestamp = new Date().toISOString();
    localStorage.setItem('timestamp', timestamp);

    // Create the mailto link with the user's first name, last name, and email
    const subject = encodeURIComponent('Newsletter Subscription Request');
    const body = encodeURIComponent(
      `I want to subscribe to your newsletter.\n\nDetails:\nFirst Name: ${firstName}\nLast Name: ${lastName}\nEmail: ${email}`
    );
    const mailtoLink = `mailto:felixaniekwensi@gmail.com,drainage.event.separator@gmail.com?subject=${subject}&body=${body}`;

    // Open the user's default email client
    window.location.href = mailtoLink;

    // Display success message
    setMessage('You have successfully subscribed to the Event analysis newsletter!');

    // Redirect to homepage after 2 seconds to allow user to see the message
    setTimeout(() => {
      navigate('/');
    }, 2000);

    setIsDisabled(false);
  };

  return (
    <div className="formContainer">
      <h2 className="title">Sign Up for Our Newsletter</h2>
      <p className="description">
        Join us to make the world a better place and help propagate drainage efforts in North America.
      </p>
      <form onSubmit={handleSubmit} className="form">
        <input
          type="text"
          value={firstName}
          onChange={handleFirstNameChange}
          placeholder="First Name"
          className="input"
          required
        />
        <input
          type="text"
          value={lastName}
          onChange={handleLastNameChange}
          placeholder="Last Name"
          className="input"
          required
        />
        <input
          type="email"
          value={email}
          onChange={handleEmailChange}
          placeholder="Email Address"
          className="input"
          required
        />
        <button
          type="submit"
          className="subscribeButton"
          disabled={isDisabled}
        >
          {isDisabled ? 'Subscribing...' : 'Subscribe'}
        </button>
      </form>
      {message && <p className={`message ${message.includes('failed') ? 'error' : ''}`}>{message}</p>}
    </div>
  );
};

export default SignupNewsletter;